var _style, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#192852;}\n\t.st1{fill:#192852;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 20.8,
    cy: 7.9,
    rx: 4,
    ry: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,19c0,0,2.5-0.7,4,0c0.3,0.3,1.1,0.3,1.1-1.2c0.1-1.5-0.4-2.2-0.4-2.2s-0.5-0.5-1.4-1 c-0.1-1-0.1-1.7-0.1-1.7s0.1-0.5,1.2-0.5c1.3-0.2,1.3-0.2,1.3-0.2s0.8-0.6,1.3,0.5c0.5,1.1,1.2,1.9,1.8,4.6c0.2,1,0.7,1.5-1.3,3.6 c-0.6,0.7-2.8,2.7-6.1,3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,19c0,0-2.7-0.7-4.2,0c-0.3,0.3-1.1,0.3-1.1-1.2c-0.1-1.5,0.4-2.2,0.4-2.2s0.5-0.5,1.4-1 c0.1-1,0.1-1.7,0.1-1.7s-0.1-0.5-1.2-0.5c-1.3-0.2-1.3-0.2-1.3-0.2s-0.8-0.6-1.3,0.5S4,14.5,3.4,17.3c-0.2,1-0.7,1.5,1.3,3.6 c0.6,0.7,3.3,2.7,6.7,3.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,21.8h1.8c0,0,0.7,0.3,1.1-1.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,21.8H9.9c0,0-0.7,0.3-1.2-1.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,14.5c0,0,2.2,1.1,5,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,25c0,0,2.3,1.8,5,0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.4,
    cy: 21.1,
    r: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.1,
    cy: 21.1,
    r: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,14.5c0,0-2,2.2-2.3,5.5c-0.2,1.3-0.6,3-1.3,5.4s-2.2,5.5,1.8,9.8c0.9,0.8,2.3,2,6.4,1.8 c1.1,0.1,2.5,0.1,4.1,0c1.6-0.1,7.2-1,8.1-6.8c0.2-1.4-0.6-4.8-1.5-6.6c-0.6-1.4-0.9-3.4-1.4-6c-0.3-1.2-1.5-4.5-7.4-5.7 C20.1,12,18.4,11.6,14.7,14.5z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.9,
    y1: 7.3,
    x2: 12.2,
    y2: 7.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.9,
    y1: 9.3,
    x2: 14.2,
    y2: 9.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.9,
    y1: 11.2,
    x2: 12.2,
    y2: 11.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 29.4,
    y1: 4.1,
    x2: 30.7,
    y2: 4.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.7,
    y1: 5.4,
    x2: 32.1,
    y2: 5.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 29.4,
    y1: 6.7,
    x2: 30.7,
    y2: 6.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.1,
    y1: 5.4,
    x2: 29.4,
    y2: 5.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 9.3,
    x2: 10.2,
    y2: 9.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyFat);
export default __webpack_public_path__ + "static/media/BodyFat.498556ac9ed80732b500a6966d97ee84.svg";
export { ForwardRef as ReactComponent };